import { Modal } from '@bp/ui-components';
import { AbsenceReasonForm } from 'components/Absences/forms/AbsenceReasonForm';
import { useTranslation } from 'react-i18next';

type AbsenceReasonModalProps = {
  isOpen: boolean;
  selectedReasonUuid: string | null;
  onClose: () => void;
};

export const AbsenceReasonModal = ({ isOpen, selectedReasonUuid, onClose }: AbsenceReasonModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      title={
        selectedReasonUuid
          ? t('common.editType', {
              type: t('absences.reasons.title', { count: 1 }),
            })
          : t('common.addType', {
              type: t('absences.reasons.title', { count: 1 }),
            })
      }
      width='s'
    >
      <AbsenceReasonForm selectedReasonUuid={selectedReasonUuid} onClose={onClose} />
    </Modal>
  );
};
